export const onlyDigits = /^[0-9\b]+$/;
